import Box from '@mui/material/Box';

interface Props {
  height?: string;
  width?: string;
}

export const Spacer = (props: Props) => <Box sx={props} />;
